var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 
    'overlay-custom': _vm.getOverlay === 'visible', 
    'overlay-not-init': _vm.getOverlay === '', 
		'closed-overlay': _vm.getOverlay === 'notVisible' },attrs:{"id":"overlay"},on:{"click":_vm.touched}})}
var staticRenderFns = []

export { render, staticRenderFns }